import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "@/shared/lib/utils";

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn("font-mono text-[10.5px] uppercase tracking-ge-table text-ge-faint", className)}
      {...props}
    />
  ),
);
Label.displayName = "Label";
